import React, { useMemo } from 'react';
import { Check, Search } from 'lucide-react';
import { BoardSearchPickerShell } from '../../board/board-search-filters/boardSearchPickerShell';
import { technicianInitials } from '../../board/utils/technicianInitials';
import { useUserProfilePhotos } from '../../user-management/hooks/useUserProfilePhotos';

function VchUserPickerAvatar({ user, photoUrl }) {
  const photo = String(photoUrl || '').trim();
  const label = user?.displayName || user?.email || user?.name || '';
  if (photo) {
    return (
      <span className="vch-user-picker-avatar vch-user-picker-avatar--photo" aria-hidden>
        <img src={photo} alt="" className="vch-user-picker-avatar-img" />
      </span>
    );
  }
  return (
    <span className="vch-user-picker-avatar vch-user-picker-avatar--initials" aria-hidden>
      {technicianInitials(label)}
    </span>
  );
}

export function VchUserPickerPanel({
  searchPlaceholder = 'Buscar usuário',
  searchTerm = '',
  onSearchChange,
  items = [],
  getKey,
  selectedKeys = [],
  onToggle,
  emptyMessage = 'Nenhum usuário disponível',
  listAriaLabel = 'Usuário do Verve',
}) {
  const selectedSet = new Set(selectedKeys);
  const photoSubjects = useMemo(
    () =>
      (Array.isArray(items) ? items : []).map((item) => ({
        id: item?.verveUserId || item?.id,
        hasProfilePhoto: item?.hasProfilePhoto === true,
        profilePhotoUrl: item?.profilePhotoUrl || null,
      })),
    [items]
  );
  const photoMap = useUserProfilePhotos(photoSubjects);

  return (
    <BoardSearchPickerShell>
      <div className="bsf-simple-picker-search">
        <Search size={13} strokeWidth={2} className="bsf-simple-picker-search-icon" aria-hidden />
        <input
          type="text"
          className="bsf-simple-picker-input"
          placeholder={searchPlaceholder}
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          autoFocus
        />
      </div>
      <div className="bsf-simple-picker-list vch-user-picker-list" role="listbox" aria-label={listAriaLabel}>
        {items.length > 0 ? (
          items.map((item) => {
            const key = getKey(item);
            const selected = selectedSet.has(String(key));
            const displayName = item.displayName || item.email || item.name || '—';
            const loginEmail = item.loginEmail || item.name || '—';
            const photoId = Number(item?.verveUserId || item?.id);
            const photoUrl =
              Number.isFinite(photoId) && photoId > 0 ? photoMap[String(photoId)] || null : null;
            return (
              <button
                key={key}
                type="button"
                role="option"
                aria-selected={selected}
                className={`bsf-simple-picker-item vch-user-picker-item${selected ? ' is-selected' : ''}`}
                onMouseDown={(e) => {
                  e.preventDefault();
                  onToggle(item);
                }}
              >
                <VchUserPickerAvatar user={item} photoUrl={photoUrl} />
                <span className="vch-user-picker-text">
                  <span className="vch-user-picker-name" title={displayName}>
                    {displayName}
                  </span>
                  <span className="vch-user-picker-email" title={loginEmail}>
                    {loginEmail}
                  </span>
                </span>
                <Check
                  size={12}
                  strokeWidth={2.5}
                  className="bsf-simple-picker-check"
                  aria-hidden
                />
              </button>
            );
          })
        ) : (
          <p className="bsf-simple-picker-empty">{emptyMessage}</p>
        )}
      </div>
    </BoardSearchPickerShell>
  );
}
